import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import apiv2 from '../config/apiv2';
import { DASHBOARD_PATH } from '../contants';
import { setMe } from '../features/me/meSlice';
import { useViewOptions } from '../hooks/useViewOptions';
import css from './../styles.module.css';

export const ProtectedRoute = ({
  children,
  allowedPermissions,
  validAccess = true,
}) => {
  //change trigger to !localStorage.getItem('ACCESS_TOKEN') or !cookies
  const [isAuthenticated, setAuthenticated] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

 const { currentUser } = useSelector(state => state.me);

  const checkAccess = async () => {
    try {
      const { data: currUser } = await apiv2.GET_ME();
      dispatch(setMe(currUser));
      setAuthenticated(true);

      const permissionOfCurrUser = currUser?.permission_level?.name;

      if (!allowedPermissions?.includes(permissionOfCurrUser)) {
        navigate(DASHBOARD_PATH);
      }
    } catch (error) {
      console.error(error);
    }
  };

  localStorage.getItem('ACCESS_TOKEN') && useViewOptions();

  useEffect(() => {
    if (allowedPermissions.length && localStorage.getItem('ACCESS_TOKEN')) {
      if (!currentUser) {
        checkAccess();
      }
    }
  }, []);

  useEffect(() => {
    if (currentUser) {
      setAuthenticated(true);

      const permissionOfCurrUser = currentUser?.permission_level?.name;

      if (allowedPermissions.length && !allowedPermissions?.includes(permissionOfCurrUser)) {
        navigate(DASHBOARD_PATH);
      }
    }
  }, [currentUser]);

  if (!localStorage.getItem('ACCESS_TOKEN')) {
    localStorage.removeItem('REFRESH_TOKEN');
    return <Navigate to="/login" replace />;
  }

  return (
    isAuthenticated &&
    validAccess && <main className={`${css.mainWrapper}`}>{children}</main>
  );
};
